import { Component, OnDestroy, OnInit, AfterViewInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent, ConfirmationDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { Subscription } from 'rxjs';
import { Member } from 'src/app/classes/member';
import { ReportingYear, ReportingYearData, ReportingYearMemberLink } from 'src/app/classes/reportingData';
import { Section, Twig } from 'src/app/classes/section';
import { DataService } from 'src/app/services/data.service';
import { MemberService } from 'src/app/services/member.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { SectionService } from 'src/app/services/section.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { formatNumber } from '@angular/common';
import { YearService } from 'src/app/services/year.service';
import { Environment } from 'src/app/classes/environment';
import { UserRoles } from 'src/app/classes/user';


enum SaveType { section, reportingYearMemberLink, everything }
class SaveParameters {
	type = SaveType.everything;
	sectionId = '';
}


@Component({
	selector: 'app-data-maintenance',
	templateUrl: './data-maintenance.component.html',
	styleUrls: [ './data-maintenance.component.css' ]
})
export class DataMaintenanceComponent implements OnInit, AfterViewInit, OnDestroy {

	bAdmin = false;
	bMaintenanceRights = false;

	members: Member[] = [];
	member = new Member();
	memberIdSelected = "";

	allSections: Section[] = [];
	sections: Section[] = [];
	idSectionSelected = "ALLE";
	selectedSectionsId: string[] = [];

	reportingYears: ReportingYear[] = [];
	years: ReportingYear[] = [];
	yearSelected = '';
	yearFrozen = false;
	rymls: ReportingYearMemberLink[] = [];
	ryml = new ReportingYearMemberLink();

	readonly TWIGS = this.environment.twigs;

	dataFormular: { [name: string]: ReportingYearData } = {};
	dataFormularOriginal: { [name: string]: ReportingYearData } = {};
	// y: keyof Section = 'sparteId';
	// df: dataFormul<[]> = {} as dataFormul<[]>;

	subscriptions = new Subscription();

	bInProgress = true;

	formG1: UntypedFormGroup = this._fb.group({});
	myInputs: { [name: string]: DataInput } = {};
	cEditableUntil: AbstractControl = new UntypedFormControl();

	bSaveInProgress = false;
	bInitializingInProgress = false;
	savesNeeded: SaveParameters[] = [];
	totaux: { [twigId: string]: string } = {};


	employeeNumberCtrl = new UntypedFormControl();
	capitalCtrl = new UntypedFormControl();
	lossReserveCtrl = new UntypedFormControl();



	constructor(
		public matDialog: MatDialog,
		private memberService: MemberService,
		private dataService: DataService,
		private sectionService: SectionService,
		private _fb: UntypedFormBuilder,
		private authService: AuthenticationService,
		private yearService: YearService,
		@Inject('environment') private environment: Environment,
	) {}


	ngOnInit() {

		for( let dataInput of this.environment.dataMaintenance ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}
		if( this.myInputs.dm_editable_until ) {
			this.myInputs.dm_editable_until.disabled = !this.bAdmin;
		}

		this.bAdmin = this.authService.isAdmin();
		
		if( this.bAdmin ) this.bMaintenanceRights = true;
		else {
			const user = this.authService.getCurrentUser();
			this.bMaintenanceRights = user.gruppen && user.gruppen.includes( UserRoles.MITGLIED_DATENPFLEGE );
		}
		console.log( "maintenance rights?", this.bMaintenanceRights )


		this.yearService.getAllPublished().subscribe( years => {

			console.log( "PUBLISHED YEARAS", years )			
			this.years = years;
			this.years.sort( (a,b) => { return b.bjJahr.localeCompare(a.bjJahr); } );

			this.sectionService.getAll().subscribe( allSections => {
				this.allSections = allSections;
	
				this.memberService.getManageableMembers().subscribe( members => {
					
					if( !members || !members.length ) {
						this.bInProgress = false;
						console.log( 'no members' )
						return;
					}
					this.members = members;
					this.memberIdSelected = this.members[0].mitgliedId;
					this.refreshMemberSelected();
				});
	
			});
		});

	}

	ngAfterViewInit() {

		const cEditableUntil = this.formG1.get( "dm_editable_until" );
		if( cEditableUntil ) {
			this.cEditableUntil = cEditableUntil;
			// if( this.bAdmin ) this.cEditableUntil.enable();
			// else this.cEditableUntil.disable();
		}

		this.subscriptions.add(
			this.formG1.valueChanges.subscribe( val => {
				console.log( '----- FORMG1 VALUE CHANGED', val );
				if( this.bInitializingInProgress ) return;
				// console.log( 'this.formG1.pristine', this.formG1.pristine )
				if( this.formG1.pristine ) return;

				const s = new SaveParameters();
				s.type = SaveType.reportingYearMemberLink;
				this.addSaveToDo( s );
			})
		);

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	/*
	inputChanged( event: Event, sectionId: string, twig: Twig ) {
		console.log( 'inputChanged', (event.target as any)?.value )
		if( this.checkAndFormatInput( event, sectionId, twig ) ) {
			this.saveInput( sectionId );
		}
	}
	*/
	inputKeyUp( event: KeyboardEvent, sectionId: string, twig: Twig ) {
		// console.log( 'inputKeyUp', (event.target as any)?.value )
		if( this.checkAndFormatInput( event, sectionId, twig ) ) {
			// this.saveInput( sectionId );
			this.calculateSums();
		}
	}
	inputBlurred( event: FocusEvent, sectionId: string, twig: Twig ) {
		console.log( 'inputBlurred', (event.target as any)?.value )
		if( this.checkAndFormatInput( event, sectionId, twig ) ) {
			this.saveInput( sectionId );
		}
	}

	private checkAndFormatInput(  event: Event, sectionId: string, twig: Twig ): boolean {

		const input = event.target as HTMLInputElement;
		const prevLength = input.value.length;
		let str = '' + input.value;
		// remove any character which is not a number or a comma
		str = str.replace( /([^0-9,-])+/g, '');
		// replaces comma by a dot
		str = str.replace( /([,])+/g, '.');
		const float = parseFloat( str );
		if(  ( isNaN(float) ) 
		|| ( Math.round(float) > 1000000000000000 ) ) {
			input.classList.add( "inputError" );
			return false;
		}
		input.classList.remove( "inputError" );

		this.dataFormular[sectionId][twig.id] = float;

		const posC = input.selectionStart;
		// console.log( 'posC', posC );
		let strCommaLast = "";
		if( input.value.length ) {
			if( input.value[ input.value.length-1 ] == "," ) strCommaLast = ',';
		}

		let minusZero = "";
		if( input.value.length && (input.value[0] == "-") && !float ) minusZero = "-";

		console.log( 'INPUT.VALUE =', this.floatToStr( float, twig.currency ) + strCommaLast )
		input.value = minusZero + this.floatToStr( float, twig.currency ) + strCommaLast;

		
		if( posC ) {
			const newPosC = ( input.value.length === (prevLength + 1) ) ? posC+1 : posC;
			input.setSelectionRange( newPosC, newPosC, "none" );
		}
		return true;
	}

	private removeErrorFlags() {
		const arr: HTMLCollectionOf<HTMLInputElement> = document.getElementsByTagName("input");
		for( let i = 0; i < arr.length; i++ ) {
			arr[i].classList.remove( "inputError" );
		}
	}

	private calculateSums() {
		this.totaux = {};
		for( let twig of this.TWIGS ) {
			let total = 0;
			for( let sectionId of this.selectedSectionsId ) {
				const section = this.sections.find( s => s.sparteId == sectionId );
				if( !section ) continue;
				total += +this.dataFormular[sectionId][twig.id];

			}
			this.totaux[ twig.id ] = this.floatToStr( total, twig.currency );
		}
	}

	private saveInput( sectionId: string ) {
		const s = new SaveParameters();
		s.type = SaveType.section;
		s.sectionId = sectionId;
		this.addSaveToDo( s );
	}

	private floatToStr( float: number, currency: boolean ): string {
		// if( !float && float !== 0 ) return "";
		if( !float && float !== 0 ) float = 0;
		return ( currency ) 
			? '' + formatNumber( float, 'de-DE', '1.2' ) + ' €' 
			: formatNumber( float, 'de-DE', '1.0-2' );
	}


	refreshMemberSelected() {

		const member = this.members.find( m => m.mitgliedId === this.memberIdSelected );
		if( !member ) return;
		this.member = member;

		this.bInProgress = true;
		this.memberService.getSectionsOfMember( this.member.mitgliedId ).subscribe( msLinks => {
			// console.log( 'msLinks', msLinks )

			this.sections = [];
			for( const link of msLinks ) {
				const section = this.allSections.find( s => s.sparteId == link.sparteId );
				if( !section ) {
					console.log( 'section introuvable, bug?', link );
					continue;
				}
				this.sections.push( section );
			}

			this.idSectionSelected = "ALLE";
			if( this.sections.length == 1 ) {
				this.idSectionSelected = this.sections[0].sparteId;
			}

			this.refreshData();

		});
	}

	refreshData() {

		this.bInProgress = true;
		this.dataService.getAllReportingYearsLink( this.member.mitgliedId ).subscribe( rymls => {

			this.bInProgress = false;
			this.rymls = rymls;
			// console.log( 'rymls =' )
			// console.table( rymls )

			if( this.years.length ) {
				this.yearSelected = this.years[0].bjJahr;
			}

			this.refreshSectionAndYear();

		});
	}

	refreshSectionAndYear() {

		this.removeErrorFlags();

		this.selectedSectionsId = [];
		this.dataFormular = {};
		this.dataFormularOriginal = {};


		let ryml = this.rymls.find( ryml => ryml.bjJahr == this.yearSelected );
		if( !ryml ) {
			console.error( 'ryml null SHOULNDT HAPPEN => new ryml()' )
			ryml = new ReportingYearMemberLink();
			ryml.bjJahr = this.yearSelected;
			ryml.mitgliedId = this.memberIdSelected;
		}
		this.ryml = ryml;


		const tms = this.ryml.bjmBearbeitbarBis;
		let strDate = "2000-01-01";
		if( tms ) {
			const dt = new Date();
			dt.setTime( tms );
			if( dt ) {
				const str = dt.toISOString().slice( 0, 10 );
				strDate = str;
			}
		}

		this.bInitializingInProgress = true;
		this.formG1.patchValue({
			dm_editable_until: strDate,
			bjmGeschaetzt: this.ryml.bjmGeschaetzt
		});
		// dm_number_of_customers: this.ryml.anzahlMitglieder,
		// dm_capital: this.ryml.bjmEigenkapital,
		// dm_loss_reserve: this.ryml.bjmVerlustruecklage,

		this.employeeNumberCtrl.patchValue( this.floatToStr( this.ryml.anzahlMitglieder, false ) );
		this.capitalCtrl.patchValue( this.floatToStr( this.ryml.bjmEigenkapital, true ) );
		this.lossReserveCtrl.patchValue( this.floatToStr( this.ryml.bjmVerlustruecklage, true ) );


		this.yearFrozen = false;
		if( this.ryml.bjmFreigabe ) this.yearFrozen = true;
		else if( !this.bAdmin ) {
			const dtNow = new Date();
			dtNow.setUTCHours( 0, 0, 0, 0 );
			const tmsNow = dtNow.getTime();
			if( tmsNow > this.ryml.bjmBearbeitbarBis ) this.yearFrozen = true;
			console.log( tmsNow, this.ryml.bjmBearbeitbarBis, tmsNow > this.ryml.bjmBearbeitbarBis )
		}
		console.log( "year frozen?", this.yearFrozen )

		
		if( this.yearFrozen || !this.bMaintenanceRights ) this.disableFormG1();
		else this.enableFormG1();


		for( const section of this.sections ) {

			if(  ( this.idSectionSelected === "ALLE" ) 
			|| ( section.sparteId === this.idSectionSelected )  ) {

				this.selectedSectionsId.push( section.sparteId );
				this.dataFormular[ section.sparteId ] = new ReportingYearData();
				this.dataFormularOriginal[ section.sparteId ] = new ReportingYearData();

				for( const twig of this.TWIGS ) {
					this.dataFormular[ section.sparteId ][ twig.id ] = 0;
					this.dataFormularOriginal[ section.sparteId ][ twig.id ] = 
						this.floatToStr( 0, twig.currency );
				}
			}
		}


		if( !this.ryml.daten ) {
			console.error( 
				'no data available for this year? should never happen', 
				this.yearSelected, this.ryml
			);
			return;
		}

		
		for( const ryd of this.ryml.daten ) {

			if( !this.dataFormular[ ryd.sparteId ] ) continue;

			this.dataFormular[ ryd.sparteId ] = ryd;

			for( const twig of this.TWIGS ) {

				this.dataFormularOriginal[ ryd.sparteId ][ twig.id ] = 
					this.floatToStr( +ryd[ twig.id ], twig.currency );
			}
		}

		this.calculateSums();

		setTimeout( () => {
			this.bInitializingInProgress = false;
		}, 0 );
	}


	showInfoMember() {
		const arrInfos = [ this.member.mitgliedsname ];

		let str = '';
		if( this.member.gsPLZ ) str += this.member.gsPLZ + ' ';
		if( this.member.gsOrt) str += this.member.gsOrt;
		arrInfos.push( str );

		if( this.member.gsTelefon ) arrInfos.push( this.member.gsTelefon );
		if( this.member.gsEmail ) arrInfos.push( this.member.gsEmail );
		this.matDialog.open( InfoDialogComponent, {
			width: '350px',
			data: { messages: arrInfos }
		});
	}


	sectionName( sectionId: string ): string {
		const section = this.sections.find( s => s.sparteId == sectionId );
		return section?.sparteBezeichnung || '';
	}

	addSaveToDo( saveParameters: SaveParameters ) {
		if( !this.bSaveInProgress ) {
			this.savesNeeded.push( saveParameters );
			this.launchSave();
		}
		else {

			if( saveParameters.type == SaveType.everything ) {
				this.savesNeeded = [saveParameters];
			}
			else {
				for( const s of this.savesNeeded ) {
					if( ( s.sectionId == saveParameters.sectionId )
					&& ( s.type == saveParameters.type ) ) {
						// in this case, an identical save is already planned
						console.log( 'SAVE ALREADY PLANNED')
						return;
					}
				}
				this.savesNeeded.push( saveParameters );
			}

		}
	}

	clickSaveAll() {
		const s = new SaveParameters();
		s.type = SaveType.everything;
		this.addSaveToDo( s );
	}

	async launchSave() {
		
		if( !this.savesNeeded.length ) return;
		this.bSaveInProgress = true;
		this.bInProgress = true;

		const saveNeeded = this.savesNeeded[0];
		this.savesNeeded.splice( 0, 1 );

		if( saveNeeded.type == SaveType.everything ) {
			await this.saveAll();
		}
		else if( saveNeeded.type == SaveType.reportingYearMemberLink ) {
			await this.saveReportingYearMemberLink();
		}
		else {
			await this.saveReportingYearData( saveNeeded.sectionId );
		}

		this.bSaveInProgress = false;
		this.bInProgress = false;

		if( this.savesNeeded.length ) this.launchSave();
	}

	async saveAll() {
		
		this.saveReportingYearMemberLink();
		
		if( !this.ryml.bjmId ) {
			console.log( 'ERROR there is no bjmId', this.ryml.bjmId );
			return;
		}

		for( const sectionId in this.dataFormular ) {
			await this.saveReportingYearData( sectionId );
		}

		// if( dataNeedsRefresh ) this.refreshData();
	}

	async saveReportingYearMemberLink() {

		// this.ryml = {
		//     "bjmId":"1407ccc2-bd10-4389-9247-5298296c965a",
		//     "bjJahr":"2020",
		//     "mitgliedId":"albersdorfer",
		//     "anzahlMitglieder":999,
		//     "bjmEigenkapital":0,
		//     "bjmVerlustruecklage":0,
		//     "bjmBearbeitbarBis":1619885768373,
		//     "bjmFreigabe":false,
		//     "bjmAansprechpartner":"CA1",
		// 	"bjmKommentar":"T2",
		// } as ReportingYearMemberLink;


		this.ryml.anzahlMitglieder = this.germanNumberToFloat( this.employeeNumberCtrl.value ); // this.formG1.value.dm_number_of_customers;
		this.ryml.bjmEigenkapital = this.germanNumberToFloat( this.capitalCtrl.value ); // this.formG1.value.dm_capital;
		this.ryml.bjmVerlustruecklage = this.germanNumberToFloat( this.lossReserveCtrl.value ); // this.formG1.value.dm_loss_reserve;
		this.ryml.bjmGeschaetzt = this.formG1.value.bjmGeschaetzt;
		const dt = new Date( this.formG1.value.dm_editable_until );
		if( dt ) {
			dt.setUTCHours( 13, 0, 0, 0 );
			this.ryml.bjmBearbeitbarBis = dt.getTime();
		}
		// console.log( 'SAVE REPORTINGYEARMEMBERLINK', dt, this.ryml.bjmBearbeitbarBis )

		this.bInProgress = true;
		console.log( 'this.ryml.bjmId', this.ryml.bjmId )
		if( !this.ryml.bjmId ) {
			const ryml = await this.dataService.createReportingYearMemberLink(
				'' + this.yearSelected, this.member.mitgliedId
			).toPromise();
			if( !ryml || !ryml.bjmId ) return;
			this.ryml.bjmId = ryml.bjmId;
		}
		else {
			await this.dataService.updateReportingYearMemberLink( this.ryml ).toPromise();
		}
		this.bInProgress = false;

	}
	
	async saveReportingYearData( sectionId: string ) {

		if( !this.ryml.bjmId || !this.ryml.bjmId ) {
			await this.saveReportingYearMemberLink();
		}


		const ryd = this.dataFormular[ sectionId ];
		ryd.bjmId = this.ryml.bjmId;
		ryd.sparteId = sectionId;
		console.log( 'ryd.bmdId =', ryd.bmdId )
		const bNew = !ryd.bmdId;
		const b = await this.dataService.saveReportingYearData( ryd ).toPromise();
		console.log( 'ryd.bmdId', ryd.bmdId )
		console.log( 'ryd', ryd )
		if( !b ) {
			console.log( 'error while saving ', sectionId )
			// this.refreshData();
			return;
		}
		if( bNew ) {
			// const rydsYear = this.rydMap.get( this.yearSelected );
			const nPos = this.ryml.daten.findIndex( d => d.sparteId == sectionId );
			if( nPos != -1 ) {
				this.ryml.daten.splice( nPos, 1 );
			}
			this.ryml.daten.push( ryd );
			console.log( 'bNEW', ryd )
		}
	}

	async publish() {
		if( !this.ryml ) {
			console.log( 'ryml null SHOULNDT HAPPEN' )
			return;
		}

		const dialogRef = this.matDialog.open( ConfirmationDialogComponent, {
			// width: '350px',
			data: 'Sind Sie sicher, dass Sie die Daten freigeben möchten?'
		});

		dialogRef.afterClosed().subscribe(result => {
			if( result ) {
				this.publicationConfirmed();
			}
		});
	}

	private async publicationConfirmed() {

		this.bInProgress = true;
		await this.saveAll();

		this.ryml.bjmFreigabe = true;
		const b = await this.dataService.updateReportingYearMemberLink( this.ryml ).toPromise();
		if( !b ) {
			this.ryml.bjmFreigabe = false;
		}
		else {
			this.yearFrozen = true;
			this.disableFormG1();
		}

		this.bInProgress = false;

	}

	async unpublish() {

		if( !this.ryml ) {
			console.log( 'ryl null SHOULNDT HAPPEN' )
			return;
		}

		this.bInProgress = true;
		this.ryml.bjmFreigabe = false;
		const b = await this.dataService.updateReportingYearMemberLink( this.ryml ).toPromise();
		if( !b ) {
			console.log( 'error ?!', b )
			this.ryml.bjmFreigabe = true;
		}
		else {
			this.yearFrozen = false;
			this.enableFormG1();
		}

		this.bInProgress = false;

	}

	private enableFormG1() {
		// console.log( 'enableForm()', this.bAdmin, this.cEditableUntil.disabled )

		this.formG1.enable();
		if( !this.bAdmin ) this.formG1.controls.dm_editable_until.disable();

		this.formG1.markAsPristine();
		this.formG1.markAsUntouched();

		this.employeeNumberCtrl.enable();
		this.capitalCtrl.enable();
		this.lossReserveCtrl.enable();
	}

	private disableFormG1() {

		this.formG1.disable();
		this.employeeNumberCtrl.disable();
		this.capitalCtrl.disable();
		this.lossReserveCtrl.disable();

	}




	inputKeyUpEmployee( event: KeyboardEvent ) {
		// console.log( 'inputKeyUp', (event.target as any)?.value )
		if( this.checkAndFormatInputEmployee( event ) ) {
			// this.saveInput( sectionId );
		}
	}
	inputBlurredEmployee( event: FocusEvent ) {
		console.log( 'inputBlurred', (event.target as any)?.value )
		if( this.checkAndFormatInputEmployee( event ) ) {
			this.saveReportingYearMemberLink();
		}
	}

	private checkAndFormatInputEmployee( event: Event ): boolean {

		const input = event.target as HTMLInputElement;
		const prevLength = input.value.length;
		let str = '' + input.value;
		// remove any character which is not a number or a comma
		str = str.replace( /([^0-9,-])+/g, '');
		// replaces comma by a dot
		str = str.replace( /([,])+/g, '.');
		const float = parseFloat( str );
		if(  ( isNaN(float) ) 
		|| ( Math.round(float) > 1000000000000000 ) ) {
			input.classList.add( "inputError" );
			return false;
		}
		input.classList.remove( "inputError" );


		const posC = input.selectionStart;
		// console.log( 'posC', posC );
		let strCommaLast = "";
		if( input.value.length ) {
			if( input.value[ input.value.length-1 ] == "," ) strCommaLast = ',';
		}

		let minusZero = "";
		if( input.value.length && (input.value[0] == "-") && !float ) minusZero = "-";

		console.log( 'INPUT.VALUE =', this.floatToStr( float, false ) + strCommaLast )
		input.value = minusZero + this.floatToStr( float, false ) + strCommaLast;

		
		if( posC ) {
			const newPosC = ( input.value.length === (prevLength + 1) ) ? posC+1 : posC;
			input.setSelectionRange( newPosC, newPosC, "none" );
		}
		return true;
	}


	inputKeyUpCurrency( event: KeyboardEvent ) {
		// console.log( 'inputKeyUp', (event.target as any)?.value )
		if( this.checkAndFormatInputCurrency( event ) ) {
			// this.saveInput( sectionId );
		}
	}
	inputBlurredCurrency( event: FocusEvent ) {
		console.log( 'inputBlurred', (event.target as any)?.value )
		if( this.checkAndFormatInputCurrency( event ) ) {
			this.saveReportingYearMemberLink();
		}
	}

	private checkAndFormatInputCurrency( event: Event ): boolean {

		const input = event.target as HTMLInputElement;
		const prevLength = input.value.length;
		let str = '' + input.value;
		// remove any character which is not a number or a comma
		str = str.replace( /([^0-9,-])+/g, '');
		// replaces comma by a dot
		str = str.replace( /([,])+/g, '.');
		const float = parseFloat( str );
		if(  ( isNaN(float) ) 
		|| ( Math.round(float) > 1000000000000000 ) ) {
			input.classList.add( "inputError" );
			return false;
		}
		input.classList.remove( "inputError" );


		const posC = input.selectionStart;
		// console.log( 'posC', posC );
		let strCommaLast = "";
		if( input.value.length ) {
			if( input.value[ input.value.length-1 ] == "," ) strCommaLast = ',';
		}

		let minusZero = "";
		if( input.value.length && (input.value[0] == "-") && !float ) minusZero = "-";

		console.log( 'INPUT.VALUE =', this.floatToStr( float, true ) + strCommaLast )
		input.value = minusZero + this.floatToStr( float, true ) + strCommaLast;

		
		if( posC ) {
			const newPosC = ( input.value.length === (prevLength + 1) ) ? posC+1 : posC;
			input.setSelectionRange( newPosC, newPosC, "none" );
		}
		return true;
	}

	private germanNumberToFloat( str: string ) : number {

		if( !str || !str.length ) return 0;
		str = '' + str;
		// remove any character which is not a number or a comma
		str = str.replace( /([^0-9,-])+/g, '');
		// replaces comma by a dot
		str = str.replace( /([,])+/g, '.');
		const float = parseFloat( str );
		if(  ( isNaN(float) ) 
		|| ( Math.round(float) > 1000000000000000 ) ) {
			return 0;
		}

		return float;
	}

	print() {
		window.print();
	}
	
}
